<!-- Additional Information Panel -->
<div class="info-container">
    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Date of Birth" | translate }}:
                </p>
                <p class="info-row-value">
                    {{ studentProfile.dateOfBirth | date }}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">{{ "Home Phone" | translate }}:</p>
                <a
                    class="info-row-value"
                    *ngIf='studentProfile.homePhone; else NoData'
                >
                    {{ studentProfile.homePhone | phoneFormat }}
                </a>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">{{ "Secondary email" | translate }}:</p>
                <a class="info-row-value green-text" *ngIf='studentProfile.secondaryEmail; else NoData'>
                    {{ studentProfile.secondaryEmail }}
                </a>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Gender" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.genderId; else NoData'>
                    {{ _references.getGender(studentProfile.demographic.genderId) | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Gender Specifications" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.genderSpecification; else NoData'>
                    {{ studentProfile.demographic.genderSpecification | translate}}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Do you identify as indigenous" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.indigenous; else NoData'>
                    {{_references.getIndigenous(studentProfile.demographic.indigenous) | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Indigenous specifications" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.indigenousSpecification; else NoData'>
                    {{ studentProfile.demographic.indigenousSpecification | translate}}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Country of Birth" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.countryOfBirthId; else NoData'>
                    {{ _references.getCountry(studentProfile.demographic.countryOfBirthId) | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Cultural Background" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.races; else NoData'>
                    {{_references.getRaces(studentProfile.demographic.races) | translate}}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Primary Language" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.demographic.primaryLanguageId; else NoData'>
                    {{ _references.getLanguage(studentProfile.demographic.primaryLanguageId) | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Secondary Language" | translate }}:
                </p>
                <div class="info-row-value" *ngIf='studentProfile.demographic.secondaryLanguageId; else NoData'>
                    <span *ngFor="let secondaryLanguageId of studentProfile.demographic.secondaryLanguageId; let isLast=last">
                        {{ _references.getLanguage(secondaryLanguageId) | translate }}{{isLast ? '' : ', '}} 
                    </span>
                </div>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "School you'll be attending" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.schoolId
                ?? studentProfile.registrationSchoolYear.schoolName; else NoData'>
                    {{ _references.getSchool(studentProfile.registrationSchoolYear.schoolId) 
                        ?? studentProfile.registrationSchoolYear.schoolName }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Previous School" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.previousSchoolId
                    ?? studentProfile.registrationSchoolYear.previousSchoolName; else NoData'>
                    {{ _references.getSchool(studentProfile.registrationSchoolYear.previousSchoolId) 
                        ?? studentProfile.registrationSchoolYear.previousSchoolName }}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Grade" | translate }}:
                </p>
                <div class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.gradeId; else NoData'>
                    <p>{{ _references.getGrade(studentProfile.registrationSchoolYear.gradeId) | translate }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Stream" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.streamId; else NoData'>
                    {{ _references.getStream(studentProfile.registrationSchoolYear.streamId) | translate }}
                </p>
            </div>
        </div>
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Learning Designations" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.designationId; else NoData'>
                    {{ _references.getDesignations(studentProfile.registrationSchoolYear.designationId) | translate }}
                </p>
            </div>
        </div>
    </div>

    <div class="info-row">
        <div class="info-col">
            <div class="info-content">
                <p class="info-row-label">
                    {{ "Accommodations" | translate }}:
                </p>
                <p class="info-row-value" *ngIf='studentProfile.registrationSchoolYear.accommodation; else NoData'>
                    {{ studentProfile.registrationSchoolYear.accommodation | translate }}
                </p>
            </div>
        </div>
        <div class="info-col">
           
        </div>
    </div>

    <div *ngFor="let guardian of studentProfile.guardians; index as i;">
        <h3 class="section-header">{{ "Parent/Guardian Information" | translate }} - {{i + 1}}</h3>
        <div class="info-guardian-container">
    
            <div class="info-row">
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "First Name" | translate }}:
                        </p>
                        <p class="info-row-value">
                            {{ guardian.firstName }}
                        </p>
                    </div>
                </div>
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Last Name" | translate }}:
                        </p>
                        <p class="info-row-value">
                            {{ guardian.lastName }}
                        </p>
                    </div>
                </div>
            </div>
    
            <div class="info-row">
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Pronouns" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.genderSpecification; else NoData'>
                            {{ guardian.genderSpecification | translate }}
                        </p>
                    </div>
                </div>
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Email ID" | translate }}:
                        </p>
                        <p class="info-row-value green-text" *ngIf='guardian.email; else NoData'>
                            {{ guardian.email }}
                        </p>
                    </div>
                </div>
            </div>
    
            <div class="info-row">
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Address" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.address; else NoData'>
                            {{ guardian.address }}
                        </p>
                    </div>
                </div>
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Primary contact" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.primaryContactNumber; else NoData'>
                            {{ guardian.primaryContactNumber | phoneFormat }}
                        </p>
                    </div>
                </div>
            </div>
    
            <div class="info-row">
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Secondary contact" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.secondaryContactNumber; else NoData'>
                            {{ guardian.secondaryContactNumber | phoneFormat}}
                        </p>
                    </div>
                </div>
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Primary language" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.primaryLanguageId; else NoData'>
                            {{ _references.getLanguage(guardian.primaryLanguageId) | translate }}
                        </p>
                    </div>
                </div>
            </div>
    
            <div class="info-row">
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Secondary language" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.secondaryLanguageId; else NoData'>
                            <span *ngFor="let secondaryLanguageId of guardian.secondaryLanguageId; index as i; let isLast=last">
                                {{ _references.getLanguage(secondaryLanguageId) | translate }} {{isLast ? '' : ', '}}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="info-col">
                    <!-- <div class="info-content">
                        <p class="info-row-label">
                            {{ "Relationship with student" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.guardianship; else NoData'>
                            {{ guardian.guardianship | translate }}
                        </p>
                    </div>
                </div> -->
            </div>
    
            <div class="info-row">
                <!-- <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Additional Family Info" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.guardianship; else NoData'>
                            {{ guardian.guardianship }}
                        </p>
                    </div>
                </div> -->
                <div class="info-col">
                    <div class="info-content">
                        <p class="info-row-label">
                            {{ "Any other children in the program" | translate }}:
                        </p>
                        <p class="info-row-value" *ngIf='guardian.otherStudents.length > 0; else NoData'>
                            {{ guardian.otherStudents }}
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
        <mat-divider class="divider"></mat-divider>
    </div>
    
    <h3 class="section-header">{{"Consent to contact" | translate }}</h3>
    <div *ngFor="let guardianContact of studentProfile.guardians; let i = index">
        <div>
            <p class="contact-header">{{ "Guardian" | translate }} {{i + 1}}</p>
            <p>{{ guardianContact.firstName }} {{ guardianContact.lastName }}</p>
        </div>
        <p>
            <mat-checkbox [ngClass]="guardianContact.textConsent ? '':'cross'" [disabled]="true" [checked]="guardianContact.textConsent">
                <span class="checkbox-text">{{"I would like to receive communications from Pathways by Text messages" | translate}}</span>
            </mat-checkbox>
        </p>
        <p>
            <mat-checkbox [ngClass]="guardianContact.emailConsent ? '':'cross'" [disabled]="true" [checked]="guardianContact.emailConsent">
                <span class="checkbox-text">{{"I would like to receive communications from Pathways by Email" | translate}}</span>
            </mat-checkbox>
        </p>
        
    </div>
    
    <h3 class="section-header">{{"Contact Validation" | translate}}</h3>
    <div
        class="contact-validation"
        fxLayout="row"
        fxLayoutAlign="space-between flex-end"
    >
        <div>
            <p class="contact-header">{{ "Student" | translate }}</p>
            <p >{{ studentProfile.firstName }} {{ studentProfile.lastName }}</p>
        </div>
        <p>{{ verifiedStudentContacts }}</p>
    </div>
    
    <mat-divider class="divider"></mat-divider>
    
    <div
        class="contact-validation"
        fxLayout="row"
        fxLayoutAlign="space-between flex-end"
        *ngFor="let guardianContact of studentProfile.guardians; let i = index"
    >
    <div>
        <p class="contact-header">{{ "Guardian" | translate }} {{i + 1}}</p>
        <p>{{ guardianContact.firstName }} {{ guardianContact.lastName }}</p>
    </div>
    <p style="overflow: hidden; overflow-wrap: break-word;">
        {{ verifiedGuardianContacts(guardianContact) }}
    </p>
    </div>

</div>

<ng-template #NoData ><p class="info-row-value">N/A</p></ng-template>